import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { Modal, ModalTopAction } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';

import { GetInTouchForm } from './GetInTouchForm';

export const GetInTouchModal = () => {
  const { isOpen, closeModal } = useModal(ModalId.GetInTouchModal);
  const { isMobile } = useScreenInfo();

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={() => handleCloseModal()}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [handleCloseModal]);

  return (
    <Modal
      title="Get Help"
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{
        open: isOpen,
        onClose: handleCloseModal,
        fullWidth: true,
        fullScreen: isMobile,
      }}
    >
      <GetInTouchForm handleCloseModal={handleCloseModal} />
    </Modal>
  );
};
